var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-prompt',_vm._b({staticClass:"vs-modal",attrs:{"active":_vm.active,"parent":_vm.parent},on:{"cancel":_vm.onCancel,"accept":_vm.onAccept,"close":_vm.onClose}},'vs-prompt',_vm.$props,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }